import { PropertyType } from '@rappider/rappider-components/utils';
import { SchemaRowItem } from '..';

export const INITIAL_DATA: SchemaRowItem = {
  sourceScript: null,
  function: null,
  targetScript: null,
  propertyType: PropertyType.String
};
